import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { raceKeys } from '../queries/keys';
import { racePaths } from '../queries/paths';

// TSS vite/03 — server-state hooks for races (api-reference/admin-races.md).

export function useRacesList(filters) {
    return useQuery({
        queryKey: raceKeys.list(filters),
        queryFn:  ({ signal }) => api.get(racePaths.list(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

export function useRace(id) {
    return useQuery({
        queryKey: raceKeys.detail(id),
        queryFn:  ({ signal }) => api.get(racePaths.detail(id), { signal }).then(r => r.data),
        enabled:  !!id && id !== 'new',
    });
}

export function useCreateRace() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(racePaths.list(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: raceKeys.all }),
    });
}

export function useUpdateRace(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(racePaths.detail(id), payload).then(r => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: raceKeys.detail(id) });
            qc.invalidateQueries({ queryKey: raceKeys.all });
        },
    });
}

export function useDeleteRace() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(racePaths.detail(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: raceKeys.all }),
    });
}
